import React, { useState, useEffect } from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';

/**
 * RobustSelect - A wrapper around shadcn Select to prevent the second-click error
 * 
 * The issue occurs when the Select component tries to measure content before it's fully rendered.
 * This wrapper ensures proper initialization and prevents ResizeObserver errors.
 */
function RobustSelect({ 
  value, 
  onValueChange, 
  placeholder = 'Select an option', 
  children, 
  className,
  disabled = false,
  defaultValue,
  testId,
  ...props 
}) {
  // Ensure we always have a valid value (never undefined)
  const [internalValue, setInternalValue] = useState(value || defaultValue || '');
  const [key, setKey] = useState(0);

  // Sync internal value with external value
  useEffect(() => {
    if (value !== undefined) {
      setInternalValue(value);
    }
  }, [value]);

  const handleValueChange = (newValue) => {
    setInternalValue(newValue);
    if (onValueChange) {
      onValueChange(newValue);
    }
  };

  // Force remount if component gets into bad state
  const handleOpenChange = (open) => {
    if (!open && props.onOpenChange) {
      props.onOpenChange(open);
    }
  };

  return (
    <Select
      key={key}
      value={internalValue}
      onValueChange={handleValueChange}
      disabled={disabled}
      onOpenChange={handleOpenChange}
      {...props}
    >
      <SelectTrigger className={className} data-testid={testId}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {children}
      </SelectContent>
    </Select>
  );
}

export default RobustSelect;
